import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-details-itams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-details-itams.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { CreateApplicationDetailsItamsConstants } from "./create-application-details-itams.constants";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { Validators } from "@angular/forms";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
export let CreateApplicationDetailsItamsComponent = class CreateApplicationDetailsItamsComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appControllerService;
    changeDetectorRef;
    // Labels
    descriptionLabel = CreateApplicationDetailsItamsConstants.DESCRIPTION_LABEL;
    applicationTypeLabel = CreateApplicationDetailsItamsConstants.APPLICATION_TYPE_LABEL;
    tradingGoodsLabel = CreateApplicationDetailsItamsConstants.TRADING_GOODS_LABEL;
    tradingGoodsDescriptionLabel = CreateApplicationDetailsItamsConstants.TRADING_GOODS_DESCRIPTION_LABEL;
    previousApplicationReferenceNumberLabel = CreateApplicationDetailsItamsConstants.PREVIOUS_APPLICATION_REFERENCE_NUMBER_LABEL;
    // Form controls
    descriptionFormControlName = CreateApplicationDetailsItamsConstants.DESCRIPTION_FORM_CONTROL_NAME;
    applicationTypeFormControlName = CreateApplicationDetailsItamsConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    tradingGoodsFormControlName = CreateApplicationDetailsItamsConstants.TRADING_GOODS_CONTROL_NAME;
    tradingGoodsDescriptionFormControlName = CreateApplicationDetailsItamsConstants.TRADING_GOODS_DESCRIPTION_FORM_CONTROL_NAME;
    previousApplicationReferenceNumberFormControlName = CreateApplicationDetailsItamsConstants.PREVIOUS_APPLICATION_REFERENCE_NUMBER_CONTROL_NAME;
    // constants
    validationMessages = CreateApplicationDetailsItamsConstants.VALIDATION_MESSAGES;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    // variables
    detailsForm;
    applicationTypes = [];
    tradingGoods = [];
    tradingGoodIsRequired = false;
    showPreviousApplicationReferenceNumberField = false;
    constructor(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, appControllerService, changeDetectorRef) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appControllerService = appControllerService;
        this.changeDetectorRef = changeDetectorRef;
    }
    ngOnInit() {
        this.initForm();
        this.getLookups();
    }
    loadMetadata(stepMeta) {
    }
    onTradingGoodsSelected($event) {
        const selectedTradingGoods = $event.target?.value;
        const tradingGoodsDescriptionFormControl = this.detailsForm.get(this.tradingGoodsDescriptionFormControlName);
        if (selectedTradingGoods && selectedTradingGoods.trim().toLowerCase() === "other") {
            tradingGoodsDescriptionFormControl.addValidators(Validators.required);
            tradingGoodsDescriptionFormControl.updateValueAndValidity();
            this.tradingGoodIsRequired = true;
        }
        else {
            tradingGoodsDescriptionFormControl.clearValidators();
            tradingGoodsDescriptionFormControl.updateValueAndValidity();
            this.tradingGoodIsRequired = false;
        }
        this.changeDetectorRef.detectChanges();
    }
    onApplicationTypeSelected($event) {
        const selectedApplicationType = $event.target?.value;
        const previousApplicationReferenceNumberFormControl = this.detailsForm.get(this.previousApplicationReferenceNumberFormControlName);
        if (selectedApplicationType && selectedApplicationType.trim().toLowerCase() === "renewal") {
            previousApplicationReferenceNumberFormControl.addValidators(Validators.required);
            previousApplicationReferenceNumberFormControl.updateValueAndValidity();
            this.showPreviousApplicationReferenceNumberField = true;
        }
        else {
            previousApplicationReferenceNumberFormControl.clearValidators();
            previousApplicationReferenceNumberFormControl.updateValueAndValidity();
            this.showPreviousApplicationReferenceNumberField = false;
        }
        this.changeDetectorRef.detectChanges();
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get(CreateApplicationDetailsItamsConstants.DETAILS_FORM_GROUP_NAME);
        this.detailsForm = form;
    }
    getLookups() {
        const params = {
            $filter: `(moduleId eq ${this.appControllerService.selectedModuleID}) and ((name eq '${CreateApplicationDetailsItamsConstants.APPLICATION_TYPE_LOOKUP_NAME}' and deleted eq false) or (name eq '${CreateApplicationDetailsItamsConstants.TRADING_GOODS_LOOKUP_NAME}' and deleted eq false))`
        };
        this.applicationCreateService
            .getLookupsObservable(params).subscribe({
            next: (response) => {
                this.onGetLookupsCompleted(response);
            }, error: (error) => {
                this.appControllerService.handleServerErrorMessage(CreateApplicationDetailsItamsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const applicationTypes = [];
        const tradingGoods = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name?.trim().toLowerCase() === `${CreateApplicationDetailsItamsConstants.APPLICATION_TYPE_LOOKUP_NAME?.trim().toLowerCase()}`) {
                    applicationTypes.push(JSON.parse(item.content));
                }
                if (item.name?.trim().toLowerCase() === `${CreateApplicationDetailsItamsConstants.TRADING_GOODS_LOOKUP_NAME?.trim().toLowerCase()}`) {
                    tradingGoods.push(JSON.parse(item.content));
                }
            });
            this.aflaModuleStrategyService.lookups.set(`${CreateApplicationDetailsItamsConstants.APPLICATION_TYPE_LOOKUP_NAME}`, applicationTypes);
            this.aflaModuleStrategyService.lookups.set(`${CreateApplicationDetailsItamsConstants.TRADING_GOODS_LOOKUP_NAME}`, tradingGoods);
            this.applicationTypes = applicationTypes;
            this.tradingGoods = tradingGoods;
            this.changeDetectorRef.detectChanges();
        }
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
};
CreateApplicationDetailsItamsComponent = __decorate([
    Component({
        selector: "app-create-application-details-itams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDetailsItamsComponent);
